import React, { useState } from 'react';

const PlantCard = ({ plant, onUpdate, onDelete, userRole }) => {
  const [showActions, setShowActions] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDeleteClick = () => {
    if (window.confirm('Are you sure you want to delete this plant?')) {
      onDelete(plant.id);
    }
    setShowActions(false);
  };

  return (
    <>
      {/* Embedded CSS - only loaded when this component is used */}
      <style>{`
        .plant-card {
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          border: 1px solid #e8ecef;
          overflow: hidden;
          transition: all 0.25s ease;
          position: relative;
          margin-bottom: 20px;
        }

        .plant-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        }

        .card-header {
          padding: 16px 20px;
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          border-bottom: 1px solid #e9ecef;
        }

        .plant-info-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }

        .plant-name-section h3 {
          margin: 0;
          font-size: 1.35rem;
          color: #1e3c72;
          font-weight: 700;
        }

        .card-actions {
          position: relative;
        }

        .btn-icon {
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: #6c757d;
          padding: 4px 8px;
          border-radius: 6px;
          transition: all 0.2s;
        }

        .btn-icon:hover {
          background: #e9ecef;
          color: #343a40;
        }

        .dropdown-menu {
          position: absolute;
          top: 100%;
          right: 0;
          background: white;
          border: 1px solid #dee2e6;
          border-radius: 8px;
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
          min-width: 160px;
          z-index: 10;
          overflow: hidden;
          margin-top: 4px;
        }

        .dropdown-item {
          display: flex;
          align-items: center;
          gap: 10px;
          width: 100%;
          padding: 10px 16px;
          border: none;
          background: none;
          text-align: left;
          cursor: pointer;
          color: #343a40;
          font-size: 0.95rem;
          transition: all 0.2s;
        }

        .dropdown-item:hover {
          background: #f1f3f5;
        }

        .dropdown-item.delete {
          color: #dc3545;
        }

        .dropdown-item.delete:hover {
          background: #ffebee;
        }

        .card-content {
          padding: 20px;
        }

        .plant-details {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .info-row {
          display: flex;
          justify-content: space-between;
          font-size: 0.95rem;
        }

        .info-label {
          color: #6c757d;
          font-weight: 500;
          min-width: 110px;
        }

        .info-value {
          color: #212529;
          font-weight: 500;
          text-align: right;
          flex: 1;
          word-break: break-word;
        }

        .card-footer {
          padding: 14px 20px;
          background: #f8f9fa;
          border-top: 1px solid #e9ecef;
          font-size: 0.85rem;
          color: #6c757d;
        }

        .created-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .created-by {
          font-style: italic;
        }

        .created-date {
          color: #868e96;
        }

        @media (max-width: 768px) {
          .info-row {
            flex-direction: column;
            gap: 4px;
            text-align: left;
          }

          .info-label {
            min-width: auto;
          }

          .info-value {
            text-align: left;
          }
        }
      `}</style>

      <div className="plant-card">
        <div className="card-header">
          <div className="plant-info-header">
            <div className="plant-name-section">
              <h3>{plant.plant_name}</h3>
            </div>

            <div className="card-actions">
              <button
                className="btn-icon"
                onClick={() => setShowActions(!showActions)}
                disabled={loading}
              >
                {loading ? '⋯' : '⋮'}
              </button>

              {showActions && (
                <div className="dropdown-menu">
                  {/* Edit placeholder - can be enabled later */}
                  {/* <button className="dropdown-item">
                    <span>✏️</span> Edit Plant
                  </button> */}

                  {userRole === 'admin' && (
                    <button
                      className="dropdown-item delete"
                      onClick={handleDeleteClick}
                    >
                      <span>🗑️</span> Delete
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="card-content">
          <div className="plant-details">
            <div className="info-row">
              <span className="info-label">Address:</span>
              <span className="info-value">
                {plant.address || 'Not provided'}
              </span>
            </div>

            <div className="info-row">
              <span className="info-label">Contact Person:</span>
              <span className="info-value">
                {plant.contact_name || 'Not assigned'}
              </span>
            </div>

            <div className="info-row">
              <span className="info-label">Contact Number:</span>
              <span className="info-value">
                {plant.contact_number || 'N/A'}
              </span>
            </div>
          </div>
        </div>

        <div className="card-footer">
          <div className="created-info">
            <span className="created-by">
              Added by: {plant.created_by_name || 'System'}
            </span>
            <span className="created-date">
              {plant.created_at
                ? new Date(plant.created_at).toLocaleDateString()
                : '—'}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default PlantCard;